import { CreateAreaReworkPayload } from "@types";
import { saveAreasRoute, updateAreaRework } from "src/services/areas";

export const useAreaRoute = () => {
  const cleanNumeric = (value?: any): number => {
    if (value == null) return 0;

    const stringValue = typeof value === "number" ? value.toString() : value;
    const numeric = stringValue.replace(/[^\d.,-]/g, "").replace(",", ".");
    const parsed = parseFloat(numeric);
    return isNaN(parsed) ? 0 : parsed;
  };

  const getAreaTypeId = (area: any): number => {
    const geometryType = area.geometryType?.toUpperCase();

    if (geometryType === "POLYGON") return 1;
    if (geometryType === "CIRCLE") return 2;
    if (area.points.length === 1) return 2;

    return 1;
  };

  const shouldProcessArea = (area: CreateAreaReworkPayload): boolean => {
    return typeof area.id === "number" && area.scope !== "GLOBAL";
  };

  const createAreaRequest = (area: CreateAreaReworkPayload, newRouteId: string, areaTypeId: number) => {
    return {
      ...area,
      routeIds: [...(area?.routeIds ?? []), newRouteId],
      velocityMin: cleanNumeric(area.velocityMin),
      velocityMax: cleanNumeric(area.velocityMax),
      stayTimeMin: cleanNumeric(area.stayTimeMin),
      stayTimeMax: cleanNumeric(area.stayTimeMax),
      areaTypeId,
    };
  };

  const saveAreaNewRoute = async (
    newRouteId: string,
    areasRework: CreateAreaReworkPayload[],
    areasCopyRework?: CreateAreaReworkPayload[]
  ) => {
    let ids = [];
    const findActive = areasCopyRework?.filter((res) => res.selected);

    if (areasRework?.length > 0) {
      for (const area of areasRework) {
        if (area?.id) {
          ids.push(area.id);
        }

        if (!shouldProcessArea(area)) continue;

        const areaTypeId = getAreaTypeId(area);
        const areaRequest = createAreaRequest(area, newRouteId, areaTypeId);

        if (area?.id) {
          await updateAreaRework(area.id, areaRequest);
        }
      }
    } else if (findActive) {
      for (const area of findActive) {
        const areaTypeId = getAreaTypeId(area);
        const areaRequest = createAreaRequest(area, newRouteId, areaTypeId);
        
        await updateAreaRework(area.id, {
          ...areaRequest,
          selected: false,
          routeIds: [newRouteId],
        });
      }
    }

    const payload = {
      areasId: ids,
    };

    await saveAreasRoute(newRouteId, payload);
  };

  return {
    cleanNumeric,
    getAreaTypeId,
    shouldProcessArea,
    createAreaRequest,
    saveAreaNewRoute,
  };
};

